import auth from "./auth";
import axios from "axios";
let LANGUAGE_CODE = window.navigator.language;
let COUNTRY_CODE = null;
let GEOLOCATION = Intl.DateTimeFormat().resolvedOptions().timeZone;
import { cookie, hashString, formatMobileNumber } from "../utils/index";
import { add } from "lodash";

window.dataLayer = window.dataLayer || [];

async function getUserInfo() {
	let userInfo = null;
	try {
		userInfo = (await axios.get(window.USERINFO_URL)).data;
		if (userInfo.language) LANGUAGE_CODE = userInfo.language;
		if (userInfo.country) COUNTRY_CODE = userInfo.country;
		if (userInfo.geo) GEOLOCATION = userInfo.geo;
		updateCookies();
	} catch (e) {
		console.warn("[ANALYTICS] [getUserInfo] Unable to get user info", e);
	}
}

function updateCookies() {
	const token = localStorage.token ? JSON.parse(localStorage.token) : null;
	if (!token) return;
	const cid =
		cookie.get("_ga").split(".")[2] + "." + cookie.get("_ga").split(".")[3];
	console.log(`[ANALYTICS] Got cid as ${cid}`);

	const savedCid = localStorage.cid ? localStorage.cid : null;

	const ga4cid =
		cookie.get("_ga").split(".")[2] + "." + cookie.get("_ga").split(".")[3];
	console.log(`[ANALYTICS] Got GA4cid  as ${ga4cid}`);

	const savedGa4Cid = localStorage.ga4cid ? localStorage.ga4cid : null;

	const ga4sid = cookie.get(COOKIE_ID).split(".")[2];
	console.log(`[ANALYTICS] Got GA4 sessionid as ${ga4sid}`);

	const savedSid = localStorage.ga4sid ? localStorage.ga4sid : null;

	if (savedSid == ga4sid && savedCid == cid && savedGa4Cid == ga4cid) {
		console.log(`[ANALYTICS] [updateCookies] Already saved cid ${ga4sid}`);
		return;
	}

	axios({
		method: "post",
		url: USERINFO_URL,
		headers: {
			"x-ga-cid": cid,
			"x-ga4-cid": ga4cid,
			"x-ga4-sid": ga4sid,
			authorization: `bearer ${token}`,
		},
	})
		.then((res) => {
			localStorage.cid = cid;
			localStorage.ga4cid = ga4cid;
			localStorage.ga4sid = ga4sid;
			console.log("[ANALYTICS] [updateCookies] Saved cid as", cid);
			console.log("[ANALYTICS] [updateCookies] Saved GA4cid as", ga4cid);
			console.log("[ANALYTICS] [updateCookies] Saved GA4 sessionid as", ga4sid);
		})
		.catch((err) => {});
}

async function decorateDatalayerPayload(payload) {
	// Clone payload to avoid direct mutation
	let decorated = Object.assign({}, payload);

	// Retrieve user information
	const user = auth.getUser();

	if (user) {
		// Add user-specific properties to the decorated payload
		Object.assign(decorated, {
			userId: user.id,
			profile_id: user.id,
			mobileNumber: user.mobile,
			mobile: user.mobile,
			userBalance: user.balance,
			bonusBalance: user.bonus,
			pointsBalance: user.points,
			user: {
				mobile: user.mobile,
				profile_id: user.id,
				id: user.id,
				user_id: user.id,
				wallet_balance: user.balance,
				points_balance: user.points,
				bonus_balance: user.bonus,
			},
		});
	}

	// Retrieve marketing source if available
	const utm_source = sessionStorage.getItem("affiliate") || "n/a";

	// Populate static and contextual information
	Object.assign(decorated, {
		app: "MOBILE_WEB",
		utm_source: utm_source,
		languageCode: LANGUAGE_CODE,
		country: COUNTRY_CODE,
		GeoLocation: GEOLOCATION,
		currency: CURRENCY,
		environment: process.env.NODE_ENV,
	});

	// Compute and assign the hashed mobile number if mobile is present
	if (decorated.user && decorated.user.mobile) {
		decorated.user.hashed_msisdn = await hashString(
			formatMobileNumber(decorated.user.mobile)
		);
	}

	console.log("[ANALYTICS] decoratedDatalayerPayload: ", decorated);
	return decorated;
}

function trackGA4Event(categoryObject, eventKey, data) {
	if (!categoryObject) {
		console.warn("[ANALYTICS] No category configuration provided");
		return;
	}

	const eventInfo = categoryObject[eventKey];
	if (!eventInfo) {
		console.warn(
			`[ANALYTICS] No event configuration found for key: ${eventKey}`
		);
		return;
	}

	// Construct payload
	const payload = Object.assign({}, data, {
		event: eventInfo.event,
		eventCategory: eventInfo.eventCategory,
	});

	// Verify required parameters
	for (const param of eventInfo.parameters || []) {
		if (payload[param] === undefined) {
			console.warn(
				`[ANALYTICS] Missing parameter: ${param} for event: ${eventKey}`
			);
			return;
		}
	}

	try {
		if (eventInfo.event !== "login" && eventInfo.event !== "registration") {
			dataLayer.push(payload);
			console.log(`[ANALYTICS] Event tracked: ${eventInfo.event}`, payload);
		} else {
			const decoratedPayload = decorateDatalayerPayload(payload);
			dataLayer.push(decoratedPayload);
			console.log(
				`[ANALYTICS] Event tracked: ${eventInfo.event}`,
				decoratedPayload
			);
		}
	} catch (e) {
		console.warn(`[ANALYTICS] Error tracking event: ${eventInfo.event}`, e);
	}
}

const analytics = {
	getUserInfo,
	trackGA4Event,
	registration: {
		// Customer starts the registration process step 1 (Phone number and send code)
		attempt(data) {
			try {
				decorateDatalayerPayload({
					event: "registrationAttempt",
					eventCategory: "Registration",
					affiliateID: data.affiliateID || null,
					mobileNumber: data.mobile || null,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [registration->attempt] Datalayer tracking failed",
					e
				);
			}
		},
		// Customer successfully saves mobile number and password
		start(data) {
			try {
				decorateDatalayerPayload({
					event: "registrationStart",
					eventCategory: "Registration",
					email: null,
					mobileNumber: data.mobile || null,
					affiliateID: data.affiliateID || null,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [registration->start] Datalayer tracking failed",
					e
				);
			}
		},
		// Customer registration successful (verified or if no OTP, successful signup)
		success(data) {
			try {
				decorateDatalayerPayload({
					event: "registrationSuccess",
					eventCategory: "Registration",
					regDate: +new Date(),
					mobileNumber: data.mobile || null,
					userId: data.user_id || null,
					affiliateID: data.affiliateID || null,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [registration->success] Datalayer tracking failed",
					e
				);
			}

			try {
				dataLayer.push({
					event: "signup",
					app: "MOBILE_WEB",
					user: {
						id: data.user_id || null,
						mobile: data.mobile || null,
					},
				});

				decorateDatalayerPayload({
					event_name: "RegisterMobileWeb",
					mobile: data.mobile || null,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[LEGACY ANALYTICS] [registration->success] Datalayer tracking failed",
					e
				);
			}
		},
		verify(data) {
			try {
				decorateDatalayerPayload({
					event: "registrationVerified",
					eventCategory: "Registration",
					verifyDate: +new Date(),
					mobileNumber: data.mobile || null,
					userId: data.user_id || null,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [registration->verify] Datalayer tracking failed",
					e
				);
			}
		},
		// Customer registration fails
		failed(data) {
			try {
				decorateDatalayerPayload({
					event: "registrationFail",
					eventCategory: "Registration",
					mobileNumber: data.mobile || null,
					affiliateID: data.affiliateID || null,
					failRegReason: data.message,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [registration->failed] Datalayer tracking failed",
					e
				);
			}
		},
	},
	login: {
		// Customer clicks login after filling in information
		attempt(data) {
			try {
				decorateDatalayerPayload({
					event: "loginAttempt",
					eventCategory: "Login",
					mobileNumber: data.mobile || null,
					user: {
						id: data.user_id || null,
						mobile: data.mobile || null,
					},
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [login->attempt] Datalayer tracking failed",
					e
				);
			}
		},
		// Customer login successfull
		success(data) {
			try {
				decorateDatalayerPayload({
					event: "loginSuccess",
					eventCategory: "Login",
					mobileNumber: data.mobile || null,
					userId: data.user_id || null,
					affiliateID: data.affiliate_id || null,
					VIPlvl: data.vip_level || null,
					userBalance: data.wallet_balance || null,
					bonusBalance: data.bonus_balance || null,
					pointsBalance: data.points_balance || null,
					user: {
						id: data.user_id || null,
						mobile: data.mobile || null,
					},
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [login->success] Datalayer tracking failed",
					e
				);
			}

			try {
				decorateDatalayerPayload({
					event_name: "LoginMobileWeb",
					profile_id: data.user_id || null,
					mobile: data.mobile || null,
					wallet_balance: data.wallet_balance || null,
					points_balance: data.points_balance || null,
					bonus_balance: data.bonus_balance || null,
				}).then((decorated) => dataLayer.push(decorated));

				decorateDatalayerPayload({
					event: "login",
					form: { type: "login", id: "login" },
					user: {
						id: data.user_id || null,
						mobile: data.mobile || null,
						wallet_balance: data.wallet_balance || null,
						points_balance: data.points_balance || null,
						bonus_balance: data.bonus_balance || null,
					},
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[LEGACY ANALYTICS] [login->success] Datalayer tracking failed",
					e
				);
			}
		},
		// Customer login failed
		failed(data) {
			try {
				decorateDatalayerPayload({
					event: "loginFailed",
					eventCategory: "Login",
					mobileNumber: data.mobile || null,
					affiliateID: data.affiliate_id || null,
					user: {
						id: data.user_id || null,
						mobile: data.mobile || null,
					},
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [login->attempt] Datalayer tracking failed",
					e
				);
			}
		},
	},
	kyc: {
		// Customer submits kyc form
		attempt(data) {
			try {
				decorateDatalayerPayload({
					event: "initialKycAttempt",
					eventCategory: "KYC",
					affiliateID: data.affiliateID || null,
					mobileNumber: data.mobile || null,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn("[ANALYTICS] [kyc->attempt] Datalayer tracking failed", e);
			}
		},
		// Customer successfully saves kyc details
		start(data) {
			try {
				decorateDatalayerPayload({
					event: "initialKycStart",
					eventCategory: "KYC",
					mobileNumber: data.mobile || null,
					affiliateID: data.affiliateID || null,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn("[ANALYTICS] [kyc->start] Datalayer tracking failed", e);
			}
		},
		// Customer kyc submission successful
		success(data) {
			try {
				decorateDatalayerPayload({
					event: "initialKycSuccess",
					eventCategory: "KYC",
					submissionDate: +new Date(),
					mobileNumber: data.mobile || null,
					userId: data.user_id || null,
					affiliateID: data.affiliateID || null,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn("[ANALYTICS] [kyc->success] Datalayer tracking failed", e);
			}

			try {
				dataLayer.push({
					event: "initialKyc",
					app: "MOBILE_WEB",
					user: {
						id: data.user_id || null,
						mobile: data.mobile || null,
					},
				});

				decorateDatalayerPayload({
					event_name: "KycMobileWeb",
					mobile: data.mobile || null,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[LEGACY ANALYTICS] [kyc->success] Datalayer tracking failed",
					e
				);
			}
		},
		// Customer registration fails
		failed(data) {
			try {
				decorateDatalayerPayload({
					event: "initialKycFail",
					eventCategory: "KYC",
					mobileNumber: data.mobile || null,
					affiliateID: data.affiliateID || null,
					failRegReason: data.message,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn("[ANALYTICS] [kyc->failed] Datalayer tracking failed", e);
			}
		},
	},
	sendCode: {
		attempt(data) {
			try {
				decorateDatalayerPayload({
					event: "sendCodeAttempt",
					eventCategory: data.type || "Code",
					mobileNumber: data.mobile || null,
					user: {
						id: data.user_id || null,
						mobile: data.mobile || null,
					},
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [code->attempt] Datalayer tracking failed",
					e
				);
			}
		},
		success(data) {
			try {
				decorateDatalayerPayload({
					event: "sendCodeSuccess",
					eventCategory: data.type || "Code",
					mobileNumber: data.mobile || null,
					user: {
						id: data.user_id || null,
						mobile: data.mobile || null,
					},
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [code->success] Datalayer tracking failed",
					e
				);
			}
		},
		failed(data) {
			try {
				decorateDatalayerPayload({
					event: "sendCodeFailed",
					eventCategory: data.type || "Code",
					mobileNumber: data.mobile || null,
					user: {
						id: data.user_id || null,
						mobile: data.mobile || null,
					},
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn("[ANALYTICS] [code->failed] Datalayer tracking failed", e);
			}
		},
	},
	reset: {
		// Customer clicks reset after filling in phone number
		attempt(data) {
			try {
				decorateDatalayerPayload({
					event: "resetPasswordAttempt",
					eventCategory: "Reset",
					mobileNumber: data.mobile || null,
					user: {
						id: data.user_id || null,
						mobile: data.mobile || null,
					},
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [reset->attempt] Datalayer tracking failed",
					e
				);
			}
		},
		// Customer reset password successful
		success(data) {
			try {
				decorateDatalayerPayload({
					event: "resetPasswordSuccess",
					eventCategory: "Reset",
					mobileNumber: data.mobile || null,
					userId: data.user_id || null,
					user: {
						id: data.user_id || null,
						mobile: data.mobile || null,
					},
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [reset->success] Datalayer tracking failed",
					e
				);
			}
		},
		// Customer reset failed
		failed(data) {
			try {
				decorateDatalayerPayload({
					event: "resetPasswordFailed",
					eventCategory: "Reset",
					mobileNumber: data.mobile || null,
					user: {
						id: data.user_id || null,
						mobile: data.mobile || null,
					},
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [reset->failed] Datalayer tracking failed",
					e
				);
			}
		},
	},
	logout: {
		success() {
			try {
				decorateDatalayerPayload({
					event: "logoutSuccess",
					eventCategory: "Logout",
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [logout->success] Datalayer tracking failed",
					e
				);
			}
		},
	},
	deposit: {
		// Customer clicks deposit after filling in information
		attempt(data) {
			try {
				decorateDatalayerPayload({
					event: "depositAttempt",
					eventCategory: "Deposit",
					depositMethod: data.depositMethod || null,
					depositAmount: data.depositAmount || null,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [deposit->attempt] Datalayer tracking failed",
					e
				);
			}
		},
		// Customer successfully starts the deposit process
		start(data) {
			try {
				decorateDatalayerPayload({
					event: "depositPending",
					eventCategory: "Deposit",
					depositMethod: data.depositMethod || null,
					depositAmount: data.depositAmount || null,
				}).then((decorated) => dataLayer.push(decorated));

				if (data.isFirstDeposit) {
					decorateDatalayerPayload({
						event: "firstDeposit",
						eventCategory: "Deposit",
						depositMethod: data.depositMethod || null,
						depositAmount: data.depositAmount || null,
					}).then((decorated) => dataLayer.push(decorated));
				} else {
					decorateDatalayerPayload({
						event: "repeatingDeposit",
						eventCategory: "Deposit",
						depositMethod: data.depositMethod || null,
						depositAmount: data.depositAmount || null,
					}).then((decorated) => dataLayer.push(decorated));
				}
			} catch (e) {
				console.warn(
					"[ANALYTICS] [deposit->start] Datalayer tracking failed",
					e
				);
			}

			try {
				decorateDatalayerPayload({
					event_name: "DepositMobileWeb",
					app_name: "MOBILE_WEB",
					amount: data.depositAmount,
				}).then((decorated) => dataLayer.push(decorated));

				decorateDatalayerPayload({
					event: "depositInitiated",
					app: "MOBILE_WEB",
					deposit: {
						amount: data.depositAmount,
					},
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {}
		},
		// Customer fails to start the deposit process
		failed(data) {
			try {
				decorateDatalayerPayload({
					event: "depositFailed",
					eventCategory: "Deposit",
					depositMethod: data.depositMethod || null,
					depositAmount: data.depositAmount || null,
					depositFailureReason: data.message || null,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [deposit->failed] Datalayer tracking failed",
					e
				);
			}
		},
		// Customer successfully completes a deposit (Backend)
		success(data) {},
		// Customer successfully completes a first time deposit (Backend)
		first(data) {},
		// Customer successfully completes a repeat deposit (Backend)
		repeat(data) {},
	},
	withdraw: {
		// Customer clicks withdraw after filling in information
		attempt(data) {
			try {
				decorateDatalayerPayload({
					event: "withdrawAttempt",
					eventCategory: "Withdraw",
					withdrawMethod: data.withdrawMethod || null,
					withdrawAmount: data.withdrawAmount || null,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [withdraw->deposit] Datalayer tracking failed",
					e
				);
			}
		},
		// Customer successfully starts the withdrawal process
		start(data) {
			try {
				decorateDatalayerPayload({
					event: "withdrawPending",
					eventCategory: "Withdraw",
					withdrawMethod: data.withdrawMethod || null,
					withdrawAmount: data.withdrawAmount || null,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [withdraw->pending] Datalayer tracking failed",
					e
				);
			}

			try {
				decorateDatalayerPayload({
					event_name: "WithdrawMobileWeb",
					app_name: "MOBILE_WEB",
					amount: data.withdrawAmount,
				}).then((decorated) => dataLayer.push(decorated));

				decorateDatalayerPayload({
					event: "withdrawSuccessful",
					app: "MOBILE_WEB",
					withdraw: {
						amount: data.withdrawAmount,
					},
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[LEGACY ANALYTICS] [withdraw->pending] Datalayer tracking failed",
					e
				);
			}
		},
		// Customer fails to start the withdrawal process
		failed(data) {
			try {
				decorateDatalayerPayload({
					event: "withdrawFailed",
					eventCategory: "Withdraw",
					withdrawMethod: data.withdrawMethod || null,
					withdrawAmount: data.withdrawAmount || null,
					withdrawFailureReason: data.message || null,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [withdraw->failed] Datalayer tracking failed",
					e
				);
			}
		},
		// Customer successfully completes a withdrawal (Backend)
		success(data) {},
		// Customer withdrawal pending (Backend)
		pending(data) {},
		// Customer cancels a withdrawal (Backend)
		cancel(data) {},
	},
	bet: {
		sportsbook: {
			add(data) {
				try {
					decorateDatalayerPayload({
						event: "sportsbookBetAdd",
						eventCategory: "Sportsbook",
						bet_type: data.bet_type,
						parent_match_id: data.parent_match_id,
						game_position: data.game_position,
					}).then((decorated) => dataLayer.push(decorated));
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->sportsbook->add] Datalayer tracking failed",
						e
					);
				}
			},
			start(data) {
				try {
					decorateDatalayerPayload({
						event: "sportsbookBetAttempt",
						eventCategory: "Sportsbook",
						betType: data.bet_type,
						numOfBets: data.no_of_bets,
						stake: data.bet_amount,
						events: data.events,
					}).then((decorated) => dataLayer.push(decorated));
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->sportsbook->start] Datalayer tracking failed",
						e
					);
				}
			},
			success(data) {
				try {
					decorateDatalayerPayload({
						event: "sportsbookBetPlacement",
						eventCategory: "Sportsbook",
						betType: data.bet_type,
						numOfBets: data.no_of_bets,
						stake: data.bet_amount,
						betId: data.params.bet_id,
						shortBetId: data.params.short_bet_id,
						ticketId: data.ticketId,
						events: data.events,
						message: data.message,
					}).then((decorated) => dataLayer.push(decorated));
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->sportsbook->success] Datalayer tracking failed",
						e
					);
				}

				// Legacy datalayer
				try {
					decorateDatalayerPayload({
						event_name: "PlaceBetMobileWeb",
						app_name: "MOBILE_WEB",
						betType: data.bet_type,
						num_items: data.no_of_bets,
						amount: data.bet_amount,
						channel: "mobile_web",
						events: data.events,
						bet_id: data.bet_id,
					}).then((decorated) => dataLayer.push(decorated));

					decorateDatalayerPayload({
						event: data.first_bet ? "firstBet" : "betPlacedSuccessful",
						app: "MOBILE_WEB",
						bet: {
							id: data.bet_id,
							amount: data.bet_amount,
							betType: data.bet_type,
							numberOfMatches: data.no_of_bets,
							odds: data.total_odds,
							events: data.events,
						},
					}).then((decorated) => dataLayer.push(decorated));
				} catch (e) {
					console.warn(
						"[LEGACY ANALYTICS] [bet->sportsbook->success] Datalayer tracking failed",
						e
					);
				}
			},
			failed(data) {
				try {
					decorateDatalayerPayload({
						event: "sportsbookBetFailed",
						eventCategory: "Sportsbook",
						betType: data.bet_type,
						numOfBets: data.no_of_bets,
						stake: data.bet_amount,
						message: data.message,
						events: data.events,
					}).then((decorated) => dataLayer.push(decorated));
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->sportsbook->failed] Datalayer tracking failed",
						e
					);
				}
			},
		},
		virtuals: {
			add(data) {
				try {
					decorateDatalayerPayload({
						event: "virtualsBetAdd",
						eventCategory: "Virtuals",
						bet_type: data.bet_type,
						parent_match_id: data.parent_match_id,
					}).then((decorated) => dataLayer.push(decorated));
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->virtuals->add] Datalayer tracking failed",
						e
					);
				}
			},
			start(data) {
				try {
					decorateDatalayerPayload({
						event: "virtualsBetAttempt",
						eventCategory: "Virtuals",
						betType: data.bet_type,
						numOfBets: data.no_of_bets,
						stake: data.bet_amount,
					}).then((decorated) => dataLayer.push(decorated));
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->virtuals->start] Datalayer tracking failed",
						e
					);
				}
			},
			success(data) {
				try {
					decorateDatalayerPayload({
						event: "virtualsBetPlacement",
						eventCategory: "Virtuals",
						betType: data.bet_type,
						numOfBets: data.no_of_bets,
						stake: data.bet_amount,
						betId: data.bet_id,
						message: data.message,
					}).then((decorated) => dataLayer.push(decorated));
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->virtuals->success] Datalayer tracking failed",
						e
					);
				}

				try {
					decorateDatalayerPayload({
						event_name: "PlaceBetMobileWeb",
						app_name: "MOBILE_WEB",
						betType: "virtuals",
						num_items: data.no_of_bets,
						amount: data.bet_amount,
						channel: "mobile_web",
						bet_id: data.bet_id,
					}).then((decorated) => dataLayer.push(decorated));

					decorateDatalayerPayload({
						event_name: "betPlacedSuccessful",
						app: "MOBILE_WEB",
						bet: {
							id: data.bet_id,
							amount: data.bet_amount,
							betType: "virtual",
							numberOfMatches: data.no_of_bets,
							odds: data.total_odds,
						},
					}).then((decorated) => dataLayer.push(decorated));
				} catch (e) {
					console.warn(
						"[LEGACY ANALYTICS] [bet->virtuals->success] Datalayer tracking failed",
						e
					);
				}
			},
			failed(data) {
				try {
					decorateDatalayerPayload({
						event: "virtualsBetFailed",
						eventCategory: "Virtuals",
						betType: data.bet_type,
						numOfBets: data.no_of_bets,
						stake: data.bet_amount,
						message: data.message,
					}).then((decorated) => dataLayer.push(decorated));
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->virtuals->failed] Datalayer tracking failed",
						e
					);
				}
			},
		},
		shikisha: {
			add(data) {
				try {
					decorateDatalayerPayload({
						event: "shikishaBetAdd",
						eventCategory: "Sportsbook",
						bet_type: data.bet_type,
						parent_match_id: data.parent_match_id,
					}).then((decorated) => dataLayer.push(decorated));
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->shikisha->add] Datalayer tracking failed",
						e
					);
				}
			},
			start(data) {
				try {
					decorateDatalayerPayload({
						event: "shikishaBetAttempt",
						eventCategory: "Shikisha",
						betType: data.bet_type,
						numOfBets: data.no_of_bets,
						stake: data.bet_amount,
					}).then((decorated) => dataLayer.push(decorated));
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->shikisha->start] Datalayer tracking failed",
						e
					);
				}
			},
			success(data) {
				try {
					decorateDatalayerPayload({
						event: "shikishaBetPlacement",
						eventCategory: "Shikisha",
						betType: data.bet_type,
						numOfBets: data.no_of_bets,
						stake: data.bet_amount,
						betId: data.bet_id,
						message: data.message,
					}).then((decorated) => dataLayer.push(decorated));
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->shikisha->success] Datalayer tracking failed",
						e
					);
				}

				try {
					decorateDatalayerPayload({
						event_name: "PlaceBetMobileWeb",
						app_name: "MOBILE_WEB",
						betType: "shikisha",
						num_items: data.no_of_bets,
						amount: data.bet_amount,
						channel: "mobile_web",
						bet_id: data.bet_id,
					}).then((decorated) => dataLayer.push(decorated));

					decorateDatalayerPayload({
						event: data.first_bet ? "firstBet" : "betPlacedSuccessful",
						app: "MOBILE_WEB",
						bet: {
							id: data.bet_id,
							amount: data.bet_amount,
							betType: "shikisha",
							numberOfMatches: data.no_of_bets,
							odds: data.total_odds,
						},
					}).then((decorated) => dataLayer.push(decorated));
				} catch (e) {
					console.warn(
						"[LEGACY ANALYTICS] [bet->shikisha->success] Datalayer tracking failed",
						e
					);
				}
			},
			failed(data) {
				try {
					decorateDatalayerPayload({
						event: "shikishaBetFailed",
						eventCategory: "Shikisha",
						betType: data.bet_type,
						numOfBets: data.no_of_bets,
						stake: data.bet_amount,
						message: data.message,
					}).then((decorated) => dataLayer.push(decorated));
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->shikisha->failed] Datalayer tracking failed",
						e
					);
				}
			},
		},
		jackpots: {
			add(data) {
				try {
					decorateDatalayerPayload({
						event: "jackpotBetAdd",
						eventCategory: "Jackpot",
						bet_type: data.bet_type,
						parent_match_id: data.parent_match_id,
					}).then((decorated) => dataLayer.push(decorated));
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->jackpots->add] Datalayer tracking failed",
						e
					);
				}
			},
			autopick(data) {
				try {
					decorateDatalayerPayload({
						event: "jackpotBetAutopick",
						eventCategory: "Jackpot",
						betType: data.bet_type,
						jackpotEventId: data.event_id,
					}).then((decorated) => dataLayer.push(decorated));
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->jackpots->autopick] Datalayer tracking failed",
						e
					);
				}
			},
			start(data) {
				try {
					decorateDatalayerPayload({
						event: "jackpotBetAttempt",
						eventCategory: "Jackpot",
						betType: data.bet_type,
						numOfBets: data.no_of_bets,
						stake: data.bet_amount,
						combinations: data.combinations,
						jackpotEventId: data.event_id,
					}).then((decorated) => dataLayer.push(decorated));
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->jackpots->start] Datalayer tracking failed",
						e
					);
				}
			},
			success(data) {
				try {
					decorateDatalayerPayload({
						event: "jackpotBetPlacement",
						eventCategory: "Jackpot",
						betType: data.bet_type,
						numOfBets: data.no_of_bets,
						stake: data.bet_amount,
						combinations: data.combinations,
						jackpotEventId: data.event_id,
						message: data.message,
					}).then((decorated) => dataLayer.push(decorated));
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->jackpots->success] Datalayer tracking failed",
						e
					);
				}
			},
			failed(data) {
				try {
					decorateDatalayerPayload({
						event: "jackpotBetFailed",
						eventCategory: "Jackpot",
						betType: data.bet_type,
						numOfBets: data.no_of_bets,
						stake: data.bet_amount,
						combinations: data.combinations,
						jackpotEventId: data.event_id,
						message: data.message,
					}).then((decorated) => dataLayer.push(decorated));
				} catch (e) {
					console.warn(
						"[ANALYTICS] [bet->jackpots->failed] Datalayer tracking failed",
						e
					);
				}
			},
		},
	},
	casino: {
		play(data) {
			try {
				decorateDatalayerPayload({
					event: data.mode,
					eventCategory: "Casino",
					gameName: data.gameName,
					gameProvider: data.gameProvider,
					gameCode: data.gameCode,
					category: data.category,
					gameID: data.gameID,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn("[ANALYTICS] [casino->play] Datalayer tracking failed", e);
			}
		},
		close(data) {
			try {
				decorateDatalayerPayload({
					event: "closeCasinoSession",
					eventCategory: "Casino",
					gameName: data.gameName,
					gameProvider: data.gameProvider,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [casino->close] Datalayer tracking failed",
					e
				);
			}
		},
	},
	recommendations: {
		see(payload) {
			try {
				decorateDatalayerPayload({
					event: "seeRecommendation",
					eventCategory: "Recommendations",
					ids: payload.ids,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [recommendations->see] Datalayer tracking failed see",
					e
				);
			}
		},
		add(payload) {
			try {
				decorateDatalayerPayload({
					event: "addRecommendation",
					eventCategory: "Recommendations",
					id: payload.id,
					home_team: payload.home_team,
					away_team: payload.away_team,
					market: payload.market,
					odd_key: payload.odd_key,
					odd_value: payload.odd_value,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [recommendations->see] Datalayer tracking failed add",
					e
				);
			}
		},
		open(payload) {
			try {
				decorateDatalayerPayload({
					event: "openRecommendation",
					eventCategory: "Recommendations",
					id: payload.id,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [recommendations->see] Datalayer tracking failed add",
					e
				);
			}
		},
		place(payload) {
			try {
				decorateDatalayerPayload({
					event: "placeRecommendation",
					eventCategory: "Recommendations",
					ids: payload.ids,
					ref: payload.ref,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [recommendations->place] Datalayer tracking failed place",
					e
				);
			}
		},
	},
	regulatory: {
		selfExclusion(data) {},
		kycCompleted(data) {},
		cookieConsent(data) {},
	},
	general: {
		search(data) {
			try {
				decorateDatalayerPayload({
					event: "search",
					keyword: data.keyword,
					type: data.type,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [general->search] Datalayer tracking failed",
					e
				);
			}
		},
		uiSwitch(data) {
			try {
				decorateDatalayerPayload({
					event: "ui_switch",
					eventCategory: "General",
					current_ui_version: data.isNewUI ? "new" : "old",
					previous_ui_version: data.previous_ui_version,
					switch_direction: data.switch_direction,
					profileId: data.profile_id || "anonymous",
					timestamp: data.timestamp,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [general->uiSwitch] Datalayer tracking failed",
					e
				);
			}
		},
		printMatches(data) {
			try {
				decorateDatalayerPayload({
					event: "DownloadFixtures",
					type: data.type,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [general->printMatches] Datalayer tracking failed",
					e
				);
			}
		},
		pageMetaData(data) {
			try {
				decorateDatalayerPayload({
					event: "pageMetaData",
					page: {
						type: data.type,
						title: data.title,
						path: data.path,
					},
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [general->pageMetaData] Datalayer tracking failed",
					e
				);
			}
		},
		pageHit(data) {
			try {
				decorateDatalayerPayload({
					event: "pageHit",
					eventCategory: "General",
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [general->pageHit] Datalayer tracking failed",
					e
				);
			}
		},
		languageCodeChange(data) {},
		watch(payload) {
			try {
				decorateDatalayerPayload({
					event: "watch",
					provider: payload.provider,
					game: payload.event,
					parent_match_id: payload.parent_match_id,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.error("[datalayer]:: watch live tracking failed");
				console.warn(e);
			}
		},
	},
	dropMenu: {
		reOrdered(payload) {
			try {
				decorateDatalayerPayload({
					event: "dropMenuReordered",
					eventCategory: "DropMenu",
					itemsOrder: payload.itemsOrder,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [dropMenu->reOrdered] Datalayer tracking failed reOrdered",
					e
				);
			}
		},
	},
	snapika: {
		snappedMatchSuccessfully(payload) {
			try {
				decorateDatalayerPayload({
					event: "matchSnappedSuccessfully",
					eventCategory: "Snapika",
					snapDetails: payload,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [snapika->matchSnappedSuccessfully] Datalayer tracking failed matchSnappedSuccessfully",
					e
				);
			}
		},
		snappedMatchLoaded(payload) {
			try {
				decorateDatalayerPayload({
					event: "snappedMatchLoadedSuccessfully",
					eventCategory: "Snapika",
					matchDetails: payload,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [snapika->snappedMatchLoadedSuccessfully] Datalayer tracking failed snappedMatchLoadedSuccessfully",
					e
				);
			}
		},
		snappedMatchNotAvailable(payload) {
			try {
				decorateDatalayerPayload({
					event: "snappedMatchNotAvailable",
					eventCategory: "Snapika",
					parentMatchId: payload.parentMatchId,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (e) {
				console.warn(
					"[ANALYTICS] [snapika->snappedMatchNotAvailable] Datalayer tracking failed snappedMatchNotAvailable",
					e
				);
			}
		},
	},
	themeMode: {
		add(payload) {
			try {
				decorateDatalayerPayload({
					event: "dark_light_mode_toggle",
					eventCategory: "ThemeMode",
					mode_selected: payload.theme,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (error) {
				console.warn(
					"[ANALYTICS] [themeMode->see] Datalayer tracking failed add",
					e
				);
			}
		},
	},
	shareBet: {
		add(payload) {
			try {
				decorateDatalayerPayload({
					event: "share_a_bet",
					eventCategory: "ShareBet",
					platform: payload.platform,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (error) {
				console.warn(
					"[ANALYTICS] [sharebet->see] Datalayer tracking failed add",
					e
				);
			}
		},
	},
	promoAndBonusBanner: {
		add(payload) {
			try {
				decorateDatalayerPayload({
					event: "promo_click",
					eventCategory: "PromoAndBonusBanner",
					promotion_name: payload.promotion_name,
					promotion_cta: payload.promotion_cta,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (error) {
				console.warn(
					"[ANALYTICS] [promoAndBonusBanners->see] Datalayer tracking failed add",
					e
				);
			}
		},
	},
	betikaFastaCasino: {
		add(payload) {
			try {
				decorateDatalayerPayload({
					event: payload.event_name,
					eventCategory: "BetikaFastaCasino",
					game_name: payload.game_name,
					game_position: payload.game_position,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (error) {
				console.warn(
					"[ANALYTICS] [betikaFastaCasino->see] Datalayer tracking failed add",
					e
				);
			}
		},
	},
	appliedGameFilter: {
		add(payload) {
			try {
				decorateDatalayerPayload({
					event: "filter_applied",
					eventCategory: "AyppliedGameFilter",
					filter_selection: payload.filter_selection,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (error) {
				console.warn(
					"[ANALYTICS] [applyGameFilter->see] Datalayer tracking failed add",
					e
				);
			}
		},
	},
	otherGamesIframe: {
		add(payload) {
			try {
				decorateDatalayerPayload({
					event: "iframe_game_click",
					eventCategory: "IframeGame",
					iframe_game_event: payload.game_event,
					iframe_game_mode: payload.game_mode,
					iframe_game_provider: payload.game_provider,
					iframe_game_category: payload.game_category,
					iframe_game_name: payload.game_name,
					iframe_game_bet: payload.game_bet,
					iframe_game_bet_value: payload.game_bet,
					iframe_game_bet_outcome: payload.game_bet_outcome,
				}).then((decorated) => dataLayer.push(decorated));
			} catch (error) {
				console.warn(
					"[ANALYTICS] [otherGamesIframe->see] Datalayer tracking failed add",
					e
				);
			}
		},
	},
};

export default analytics;
